/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".filter-group_heading[_ngcontent-%COMP%]{margin-top:15px;font-family:'Open Sans',sans-serif!important;font-size:12px;letter-spacing:1px;font-weight:700;color:#aaa;line-height:13px;text-transform:uppercase}"];
export { styles as styles };
